module.exports = __webpack_public_path__ + "static/img/209.fe6cb49.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/200921/209.jpg
// module id = gl+M
// module chunks = 0